module.exports = __webpack_public_path__ + "static/media/bread.0a9de919.png";